const Auth = {
	isInited: false,
	async init() {
		this.isInited = true;
	},
};
export default Auth;